
class SocialShare extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll('.btn-sharing').forEach((share) => {
      share.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          const social = target.getAttribute('data-social');
          window.open(social);
        },
        false
      );
    });
  }
}

customElements.define('social-share', SocialShare);

function createArticleToc(root = document) {
  const scope = root && typeof root.querySelector === 'function' ? root : document;
  const article = scope.matches?.('.article-template')
    ? scope
    : scope.querySelector('.article-template');
  const content = article?.querySelector('.article-template__content');
  const toc = article?.querySelector('.article-toc');
  const list = toc?.querySelector('.article-toc__list');

  if (!article || !content || !toc || !list) return;

  article.articleTocObserver?.disconnect();
  article.articleTocObserver = null;
  article.classList.remove('article-template--has-toc');
  list.textContent = '';
  toc.hidden = true;

  const headings = Array.from(content.querySelectorAll('h2')).filter((heading) =>
    heading.textContent.trim()
  );

  if (headings.length < 2) return;

  const usedIds = new Set(
    Array.from(document.querySelectorAll('[id]'))
      .map((element) => element.id)
      .filter(Boolean)
  );

  const slugify = (text) => {
    const slug = text
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return slug || 'section';
  };

  const ensureId = (heading, index) => {
    if (heading.id) return heading.id;

    const baseId = `article-${slugify(heading.textContent)}-${index + 1}`;
    let id = baseId;
    let count = 2;

    while (usedIds.has(id)) {
      id = `${baseId}-${count}`;
      count += 1;
    }

    heading.id = id;
    usedIds.add(id);
    return id;
  };

  const links = headings.map((heading, index) => {
    const id = ensureId(heading, index);
    const item = document.createElement('li');
    const link = document.createElement('a');

    item.className = `article-toc__item article-toc__item--${heading.tagName.toLowerCase()}`;
    link.className = 'article-toc__link';
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();

    item.appendChild(link);
    list.appendChild(item);

    return { heading, link };
  });

  const setActiveLink = (id) => {
    links.forEach(({ heading, link }) => {
      link.classList.toggle('is-active', heading.id === id);
    });
  };

  links.forEach(({ heading, link }) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      heading.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      history.pushState(null, '', `#${heading.id}`);
      setActiveLink(heading.id);
      link.focus({ preventScroll: true });
    });
  });

  toc.hidden = false;
  article.classList.add('article-template--has-toc');

  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      const visibleEntry = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

      if (visibleEntry) {
        setActiveLink(visibleEntry.target.id);
      }
    },
    {
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    }
  );

  headings.forEach((heading) => observer.observe(heading));
  article.articleTocObserver = observer;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', createArticleToc);
} else {
  createArticleToc();
}

document.addEventListener('shopify:section:load', (event) => {
  createArticleToc(event.target);
});
